import tw, { styled } from 'twin.macro';
import { keyframes } from '@emotion/react';

const animate = keyframes`
0% {
    background-position: -1000px 0;
  }

  100% {
    background-position: 1000px 0;
  }
`;

export const Loadingbody = styled.div`
  ${tw`fixed z-50 bg-white h-screen w-full`}
`;

export const LoadingContainer = styled.div`
  ${tw`mx-auto px-4 mt-8`}
  max-width: 800px;
  & .form-loading-header {
    margin-bottom: 3rem;
  }

  & .form-loading-header .header {
    width: 40%;
    margin: 0 auto;
    height: 13px;
    border-radius: 20px;
  }

  & .light {
    opacity: 0.8;
  }

  & .lighter {
    opacity: 0.5;
  }

  & .lightest {
    opacity: 0.3;
  }

  & .form-label {
    width: 15%;
    height: 13px;
    border-radius: 20px;
    margin-bottom: 1rem;
  }

  & .form-select {
    width: 100%;
    height: 38px;
    border-radius: 3px;
  }

  & .form-loading {
    margin-bottom: 3rem;
  }

  & .loader-section {
    width: 100%;
    height: 16px;
    margin: 2rem 0;
    border-radius: 20px;
  }

  & .animate {
    animation: ${animate} 2s infinite;
    background: linear-gradient(to right, #eff1f3 4%, #e2e2e2 25%, #eff1f3 36%);
    background-size: 1000px 100%;
  }
`;
